import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { fmtEUR, fmtDate } from "../lib/format";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { RotateCcw, Trash2 } from "lucide-react";
import { toast } from "sonner";

export const InvoiceTrashDialog = ({ open, onOpenChange, onRestored }) => {
  const qc = useQueryClient();
  const { data: trash = [] } = useQuery({ queryKey: ["invoice-trash"], queryFn: api.listInvoiceTrash, enabled: open });
  const reload = () => qc.invalidateQueries({ queryKey: ["invoice-trash"] });

  const restore = async (inv) => {
    try { await api.restoreInvoice(inv.id); } catch { return toast.error("Erreur lors de la restauration"); }
    reload();
    onRestored?.();
    toast.success(`Facture ${inv.number} restaurée`);
  };
  const purge = async (inv) => {
    if (!window.confirm(`Supprimer définitivement ${inv.number} ?`)) return;
    try { await api.purgeInvoice(inv.id); } catch { return toast.error("Erreur lors de la suppression"); }
    reload();
    toast.success(`Facture ${inv.number} supprimée définitivement`);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="invoice-trash-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Corbeille</DialogTitle>
          <DialogDescription>Les factures supprimées peuvent être restaurées avec leur numéro d'origine.</DialogDescription>
        </DialogHeader>
        {trash.length ? (
          <div className="divide-y divide-slate-100">
            {trash.map((inv) => (
              <div key={inv.id} className="flex items-center justify-between gap-3 py-3" data-testid={`trash-row-${inv.number}`}>
                <div className="min-w-0">
                  <div className="font-mono text-sm text-slate-800">{inv.number} <span className="font-sans text-slate-500">— {inv.client?.name}</span></div>
                  <div className="text-xs text-slate-400">{fmtEUR(inv.total_ttc)} · supprimée le {fmtDate(inv.deleted_at)}</div>
                </div>
                <div className="flex gap-1 shrink-0">
                  <Button size="sm" className="bg-slate-900 hover:bg-slate-800" onClick={() => restore(inv)} data-testid={`restore-invoice-${inv.number}`}>
                    <RotateCcw className="h-4 w-4 mr-1.5" /> Restaurer
                  </Button>
                  <Button size="icon" variant="ghost" onClick={() => purge(inv)} title="Supprimer définitivement" data-testid={`purge-invoice-${inv.number}`}>
                    <Trash2 className="h-4 w-4 text-rose-500" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="py-8 text-center text-sm text-slate-400" data-testid="trash-empty">La corbeille est vide</p>
        )}
      </DialogContent>
    </Dialog>
  );
};
